module.exports = require('./helpers/bundle-url').getBundleURL('15MIF') + "gatheringSnmp.a3fc779e.png";